import { AccountTree, Assignment, Flag, MyLocation } from "@mui/icons-material";
// import AccountTreeIcon from "@mui/icons-material/AccountTree";
// import CrisisAlertIcon from "@mui/icons-material/CrisisAlert";
// import FolderZipIcon from "@mui/icons-material/FolderZip";
// import GroupsIcon from "@mui/icons-material/Groups";
// import LeaderboardIcon from "@mui/icons-material/Leaderboard";
// import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
// import MemoryIcon from "@mui/icons-material/Memory";
// import QueryStatsIcon from "@mui/icons-material/QueryStats";
// import WindowIcon from "@mui/icons-material/Window";
import path from "path";

// ========|| Theme Config ||========
export const HeaderHeight = 64;
export const drawerWidth = 240;
export const CONTENT_SUB_MENU_WIDTH = 180;
export const CONTENT_SIDEBAR_WIDTH = 200;
export const backgroundColor = "#f9f9fa";
export const appBasename = process.env.MIX_APP_BASENAME ?? "/";
export const homepage = "/workspace";
export const assetUrl = path.join(appBasename, "/public");
export const accessTokenCookie = "sodd-access-token";

const config = {
    APP_ENV: process.env.MIX_APP_ENV,
    COOKIE_ACCESS_TOKEN_NAME: process.env.MIX_SESSION_ACCESS_TOKEN_NAME,
    LAYOUT_BACKGROUND_COLOR: "#f9f9fa",
    LAYOUT_CONTENT_BACKGROUND_COLOR: "#f9f9fa",
    LAYOUT_CONTENT_RIGHT_SIDEBAR_WIDTH: 200,
    LAYOUT_CONTENT_SIDEBAR_WIDTH: 200,
    LAYOUT_HEADER_BACKGROUND_COLOR: "#f9f9fa",
    LAYOUT_HEADER_HEIGHT: 64,
    LAYOUT_SIDEBAR_BACKGROUND_COLOR: "white",
    LAYOUT_SIDEBAR_WIDTH: 240,
    ROUTE_HOME: "/workspace",
};

export const StrategicPlanningIcon = AccountTree;
export const StrategicPlanningObjectiveIcon = MyLocation;
export const StrategicPlanningGoalIcon = Flag;
export const StrategicPlanningActionPlanIcon = Assignment;
export const StrategicPlanningProjectIcon = Assignment;

export default config;
